import CouponContract from './CouponContract';

export default CouponContract;
